<fui-modal [state]="state">
  <fui-modal-window>
    <fui-modal-window-toolbar (closed)="cancel()" [title]="'Venue Sign Up'">
    </fui-modal-window-toolbar>
    @if (url) {
      <fui-modal-window-main>
        <fhm-app-payment-account-page-content-content [url]="url" [showClose]="true" (closed)="cancel()"></fhm-app-payment-account-page-content-content>
      </fui-modal-window-main>
    }
    <fui-modal-window-footer>
      <fui-buttons>
        <fui-action-button class="content-cancel-button"
          [title]="'fhm.common.button.cancel'"
          (click)="cancel()">
          <fui-icon [height]="12" [icon]="'close'" [width]="12"></fui-icon>
        </fui-action-button>
      </fui-buttons>
    </fui-modal-window-footer>
  </fui-modal-window>
</fui-modal>
